import { makeStyles } from '@material-ui/styles'

const Style = makeStyles ((theme) => ({
    root:{
        color:"#1D2F3F"
    }
}))

export default Style